import {
  withStyles,
} from '@material-ui/core';

import PaperWithStatus from './paperWithStatus';
import styles from './styles';

export const OverviewPaperWithStatus = (
  withStyles(styles)
)(PaperWithStatus);
